export default "__VITE_ASSET__DdT1jqbp__"